import { useTranslation } from 'react-i18next';
import { useMatch } from 'react-router-dom';

export const useRadarTemplateSteps = () => {
  const { t } = useTranslation(['modal', 'general']);
  const isPlayerSection = useMatch('/:locale/player/*');
  const step1Label = isPlayerSection ? t('createRadarTemplateModal.step1.label') : t('name', { ns: 'general' });

  return [
    { id: 'name-and-positions', label: step1Label },
    { id: 'select-metrics', label: t('createRadarTemplateModal.step2.label') },
    { id: 'select-limits', label: t('createRadarTemplateModal.step3.label') },
  ];
};
